// extracted by mini-css-extract-plugin
export default {"container":"mobile-header__container___wSR9f","closeIcon":"mobile-header__closeIcon___zXhP8"};